import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"

const HeadlineBlock = ({ block }) => {
  return <BlockWrapper block={block} showHeadline="true" showButtons="true" />
}

export default HeadlineBlock
